// React Imports
import * as React from "react";

// Mui Imports
import {Stack} from "@mui/material";

// App Imports
import ContractStatusPieChart from "./WorkWelcomeCharts/ContractStatusPieChart";
import ContractGuildPieChart from "./WorkWelcomeCharts/ContractGuildPieChart";
import ContractM4mktPieChart from "./WorkWelcomeCharts/ContractM4mktPieChart";
import ContractLevelPieChart from "./WorkWelcomeCharts/ContractLevelPieChart";
import PaymentM4mktPieChart from "./WorkWelcomeCharts/PaymentM4mktPieChart";
import PaymentContractPieChart from "./WorkWelcomeCharts/PaymentContractPieChart";
import OwedM4mktPieChart from "./WorkWelcomeCharts/OwedM4mktPieChart";
import OwedContractPieChart from "./WorkWelcomeCharts/OwedContractPieChart";


// main function
export default function WorkWelcomeLayout(props) {

    return (


        <div>
            {/*<WorkStatsFrame/>*/}
            < Stack direction="row" spacing={4}>
                <div>
                    <h3 style={{textAlign: 'center'}}>Contracts by Status</h3>
                    <ContractStatusPieChart/>
                </div>
                <div>
                    <h3 style={{textAlign: 'center'}}>Contracts by Guild</h3>
                    <ContractGuildPieChart/>
                </div>
                <div>
                    <h3 style={{textAlign: 'center'}}>Contracts by Made For</h3>
                    <ContractM4mktPieChart/>
                </div>
                <div>
                    <h3 style={{textAlign: 'center'}}>Contracts by Level</h3>
                    <ContractLevelPieChart/>
                </div>
            </Stack>
            < Stack direction="row" spacing={4}>\
                <div>
                    <h3 style={{textAlign: 'center'}}>Owed Status By Contract</h3>
                    <OwedContractPieChart/>
                </div>
                <div>
                    <h3 style={{textAlign: 'center'}}>Owed Generated by Made For</h3>
                    <OwedM4mktPieChart/>
                </div>
                <div>
                    <h3 style={{textAlign: 'center'}}>Payment Status By Contract</h3>
                    <PaymentContractPieChart/>
                </div>
                <div>
                    <h3 style={{textAlign: 'center'}}>Payment Generated by Made For</h3>
                    <PaymentM4mktPieChart/>
                </div>
            </Stack>
        </div>

    );

}
